import {
  GET_BRANDS, GET_BRANDS_COMPLETED, GET_BRANDS_FAILED,
  GET_BRAND, GET_BRAND_COMPLETED, GET_BRAND_FAILED,
  ADD_BRAND, ADD_BRAND_COMPLETED, ADD_BRAND_FAILED,
  UPDATE_BRAND, UPDATE_BRAND_COMPLETED, UPDATE_BRAND_FAILED,
  UPDATE_BRAND_VISIBILITY, UPDATE_BRAND_VISIBILITY_COMPLETED, UPDATE_BRAND_VISIBILITY_FAILED,
  SEARCH_BRANDS, SEARCH_BRANDS_COMPLETED, SEARCH_BRANDS_FAILED,
  DELETE_BRAND, DELETE_BRAND_COMPLETED, DELETE_BRAND_FAILED,
  HIDE_DELETE_BRAND_MODAL, SHOW_DELETE_BRAND_MODAL,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  brands: [],
  brandsLoading: false,
  brandsError: null,
  brand: null,
  brandLoading: false,
  brandError: null,
  addingBrand: false,
  updatingBrand: false,
  updatingBrandVisibility: false,
  updateBrandVisibilityError: null,
  deleteBrandModalVisible: false,
  brandToDelete: null,
  brandDeleting: false,
  search: searchDefault,
};

const brandReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_BRANDS: return handleSearch(state, 'search', action.payload);
    case SEARCH_BRANDS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_BRANDS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_BRANDS: {
      return {
        ...state,
        brandsLoading: true,
        brands: [],
        brandsError: null,
      };
    }
    case GET_BRANDS_COMPLETED: {
      return {
        ...state,
        brandsLoading: false,
        brands: action.payload.data,
      };
    }
    case GET_BRANDS_FAILED: {
      return {
        ...state,
        brandsLoading: false,
        brandsError: action.payload,
      };
    }
    case GET_BRAND: {
      return {
        ...state,
        brandLoading: true,
        brand: null,
        brandError: null,
      };
    }
    case GET_BRAND_COMPLETED: {
      return {
        ...state,
        brandLoading: false,
        brand: action.payload,
      };
    }
    case GET_BRAND_FAILED: {
      return {
        ...state,
        brandLoading: false,
        brandError: action.payload,
      };
    }
    case ADD_BRAND: {
      return {
        ...state,
        addingBrand: true,
      };
    }
    case ADD_BRAND_COMPLETED: {
      return {
        ...state,
        addingBrand: false,
      };
    }
    case ADD_BRAND_FAILED: {
      return {
        ...state,
        addingBrand: false,
      };
    }
    case UPDATE_BRAND: {
      return {
        ...state,
        updatingBrand: true,
      };
    }
    case UPDATE_BRAND_COMPLETED: {
      return {
        ...state,
        updatingBrand: false,
      };
    }
    case UPDATE_BRAND_FAILED: {
      return {
        ...state,
        updatingBrand: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case UPDATE_BRAND_VISIBILITY: {
      return {
        ...state,
        updatingBrandVisibility: true,
        updateBrandVisibilityError: null,
      };
    }
    case UPDATE_BRAND_VISIBILITY_COMPLETED: {
      return {
        ...state,
        updatingBrandVisibility: false,
      };
    }
    case UPDATE_BRAND_VISIBILITY_FAILED: {
      return {
        ...state,
        updatingBrandVisibility: false,
        updateBrandVisibilityError: action.payload,
      };
    }
    case SHOW_DELETE_BRAND_MODAL: {
      return {
        ...state,
        deleteBrandModalVisible: true,
        brandToDelete: action.payload,
      };
    }
    case HIDE_DELETE_BRAND_MODAL: {
      return {
        ...state,
        deleteBrandModalVisible: false,
        brandToDelete: null,
      };
    }
    case DELETE_BRAND: {
      return {
        ...state,
        brandDeleting: true,
      };
    }
    case DELETE_BRAND_COMPLETED: {
      return {
        ...state,
        brandDeleting: false,
      };
    }
    case DELETE_BRAND_FAILED: {
      return {
        ...state,
        brandDeleting: false,
      };
    }
    default:
      return state;
  }
};

export default brandReducer;



// WEBPACK FOOTER //
// ./src/Brand/reducer.js